/**
 * Note create endpoints accept JSON, or multipart when files are attached.
 * Returns the request body + headers for either case.
 */
export function buildNoteRequestBody(
  fields: Record<string, string | string[] | undefined | null>,
  attachments?: File[],
  syncAttachments?: boolean,
): { data: FormData | Record<string, unknown>; headers: Record<string, string> } {
  if (!attachments?.length) {
    return { data: fields, headers: {} };
  }

  const formData = new FormData();

  Object.entries(fields).forEach(([key, value]) => {
    if (value == null) return;

    if (Array.isArray(value)) {
      value.forEach(item => formData.append(key, item));
    }
    else {
      formData.append(key, value);
    }
  });

  formData.append(`syncAttachments`, syncAttachments ? `true` : `false`);
  attachments.forEach(file => formData.append(`attachments`, file));

  return { data: formData, headers: { 'Content-Type': `multipart/form-data` } };
}
